<template>
  <div class="mediagallery media-gallery-dy mt-3 mb-1">
    <div class="gallery-item">
      <h3 class="media-gallery-title">
        {{ title }}
      </h3>
      <b-card class="card-no-found-media-dy m-auto" align="center" no-body>
        <b-card-body align="center">
          <b-row align-v="center" class="h-100">
            <b-col>
              <h2 class="no-media-text-dy">
                {{ message }}
              </h2>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "NoMedia",
  props: ["title", "message"],
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/media/NoMediaCard.vue